import { Box, FormField, MaskedInput } from 'grommet';
import { validateCountryCodeLength, validatePhoneNumberLength } from '@services/phoneNumberService';
import { countryCodeMask, phoneMaskWithoutCountryCode } from '@utils/masks';
import type { PhoneWithCountryCodeProps } from '@customTypes/types';

export const PhoneWithCountryCode = (props: PhoneWithCountryCodeProps): JSX.Element => {
  return (
    <Box direction="row" align="start" gap="small">
      <FormField
        name="countryCode"
        htmlFor="country-code"
        label="Country code"
        width="105px"
        validate={(value) => validateCountryCodeLength(value)}
        required
      >
        <MaskedInput
          id="country-code"
          name="countryCode"
          mask={countryCodeMask}
          value={props.countryCode}
          onChange={({ target }) => props.onCountryCodeChange(target.value)}
        />
      </FormField>

      <FormField
        name="phone"
        htmlFor="phone"
        label="Phone"
        width="calc(100% - 105px)"
        validate={(value) => validatePhoneNumberLength(value)}
        required
      >
        <MaskedInput
          id="phone"
          name="phone"
          mask={phoneMaskWithoutCountryCode}
          value={props.phoneNumberWithoutCountryCode}
          onChange={({ target }) =>  props.onPhoneNumberWithoutCountryCodeChange(target.value)}
        />
      </FormField>
    </Box>
  );
};
